import cx from 'classnames';

import { Heading } from 'components/Heading';

import s from './Subtitle.module.css';

export interface SubtitleProps {
  className?: string;
  children: React.ReactNode;
}

const Subtitle = ({ className, children }: SubtitleProps) => {
  return (
    <Heading as="h2" className={cx(s.root, className)}>
      {children}
    </Heading>
  );
};

export { Subtitle };
